<template>
  <div>
    <v-row>
      <v-col>
        <h1>{{ $t("report.reports") }}</h1>
      </v-col>
      <v-spacer />
      <div>
        <v-btn class="accent" to="/report/new">{{ $t("report.newDialog.openDialogButton") }}</v-btn>
      </div>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="reportList"
      :loading="$store.getters['Ajax/loading'] ? 'accent' : false"
      :sort-by.sync="pagination.sortBy"
      :sort-desc.sync="pagination.descending"
    >
      <template #item="props">
        <tr>
          <td>{{ props.item.created_at }}</td>
          <td>{{ reportTypeNames.find(v => v.value === props.item.params.report_type).text }}</td>
          <td>{{ props.item.created_by_name }}</td>
          <td style="text-align: right">
            <v-tooltip bottom>
              {{ $t("global.downloadFile") }}
              <template #activator="{on}">
                <v-btn icon v-on="on" @click="downloadReport(props.item.id)">
                  <v-icon>cloud_download</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
            <v-tooltip bottom>
              {{ $t("global.removeFile") }}
              <template #activator="{on}">
                <v-btn icon v-on="on" @click="removeReport(props.item.id)">
                  <v-icon>delete</v-icon>
                </v-btn>
              </template>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import downloadFile from "../../repository/downloadFile";
import { reportTypeNames } from "../../staticData/Report";

export default {
  name: "ReportView",
  data: () => ({
    reportList: [],
    pagination: { sortBy: "created_at", descending: true }
  }),
  computed: {
    reportTypeNames,
    headers() {
      return [
        { text: this.$t("report.headers.date"), value: "created_at" },
        { text: this.$t("report.headers.reportType"), sortable: false },
        { text: this.$t("report.headers.createdBy"), value: "created_by_name" },
        { text: "", value: "actions", sortable: false }
      ];
    }
  },
  created() {
    this.downloadReportList();
  },
  methods: {
    downloadReportList() {
      this.axios.get("report/get-list").then(resp => {
        this.reportList = resp.data;
      });
    },
    downloadReport(id) {
      downloadFile("report/download-report?reportId=" + id);
    },
    removeReport(id) {
      let result = this.$store.dispatch("confirmDialog", {
        content: this.$t("global.removeConfirm.content"),
        title: this.$t("global.removeConfirm.title")
      });
      result.then(() => {
        this.axios.post("report/delete", { id: id }).then(() => {
          this.$store.dispatch("snackbarPush", {
            text: this.$t("global.deleted")
          });
          this.downloadReportList();
        });
      });
    }
  }
};
</script>

<style scoped></style>
